/**
 * L'entrée de connexion, porteuse de la page d'où l'on part.
 *
 * Sans ce `?return=`, quelqu'un qui se connecte depuis une fiche DMC est ramené sur l'accueil
 * et doit refaire son chemin. `/sign-in` le réassainit avant d'en faire une cible de login
 * (`safeReturnPath`) — ici on ne fait que transporter, l'autorité de confiance est là-bas.
 *
 * Partagé par tout ce qui envoie se connecter : les deux barres de navigation, et les formulaires
 * qui se prennent un 401/403 en cours de route. Une seule des deux barres qui porterait le
 * return-to serait un retour qui disparaît selon la taille de l'écran.
 */

const SIGN_IN = '/sign-in';
const SIGN_UP = '/sign-up';

function withReturn(entry: string, pathname: string | null | undefined): string {
    if (!pathname || pathname === '/') return entry;

    return `${entry}?return=${encodeURIComponent(pathname)}`;
}

export function signInHref(pathname: string | null | undefined): string {
    return withReturn(SIGN_IN, pathname);
}

/** Même contrat que `signInHref` : c'est le proxy qui y envoie un visiteur sans session. */
export function signUpHref(pathname: string | null | undefined): string {
    return withReturn(SIGN_UP, pathname);
}
